import React from 'react';
import {connect} from 'react-redux';
import qs from 'qs';
import {requestDashboard} from '../../actions/action_dashboard';
import {organizationRequest} from '../../actions/action_organization';
import {PRINTABLE_WIDGETS} from '../../constants';
import {extractSurveyDates, generateAnalyticsId} from '../../utils/analytics';
import CoverPage from './print/CoverPage';
import PageWidget from './print/PageWidget';
import PrintDialog from './print/PrintDialog';
import PrintProgress from './print/PrintProgress';

class PrintableDashboard extends React.Component {
    componentDidMount() {
        const {location} = this.props;
        const queryString = qs.parse(location.search, {ignoreQueryPrefix: true});

        this.styleNode = document.createElement('style');
        this.styleNode.innerHTML = '@page {size: A4 landscape}';
        document.head.append(this.styleNode);
        this.props.organizationRequest();
        this.props.requestDashboard(this.props.match.params.id, queryString.startDate, queryString.endDate, queryString.instanceType);
    }

    componentWillUnmount() {
        this.styleNode.remove();
        delete this.styleNode;
    }

    render() {
        const {item, loading, analytics, organization, location} = this.props;
        if (loading || !item || !analytics || !Object.keys(analytics).length || !organization) {
            return <PrintProgress progress={0} />;
        }
        const remainingItems = Object.values(analytics).filter(({loading}) => loading).length;
        if (remainingItems > 0) {
            const progress = Math.round((item.widgets.length - remainingItems) / item.widgets.length * 100);
            return <PrintProgress progress={progress} />;
        }
        document.title = item.name;
        const widgets = item.widgets.filter(({type}) => PRINTABLE_WIDGETS[type]);
        const dates = extractSurveyDates(item, analytics);

        const queryString = qs.parse(location.search, {ignoreQueryPrefix: true});
        const hints = {
            absolute: !!queryString.absolute,
            printable: true,
        };

        if (queryString.startDate) {
            dates.from = queryString.startDate;
        }

        if (queryString.endDate) {
            dates.to = queryString.endDate;
        }

        return (
            <>
                <div className="d-print-none">
                    <PrintDialog />
                </div>
                <div className="dashboard-printable">
                    <CoverPage dashboard={item} organization={organization} dates={dates} />
                    {widgets.map((w, index) => (
                        <PageWidget key={index}
                            dashboard={item} analytics={analytics[generateAnalyticsId(w)]} organization={organization} dates={dates}
                            hints={hints}
                            {...w} />
                    ))}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    analytics: state.analytics.data,
    error: state.dashboard.error,
    item: state.dashboard.item,
    loading: state.dashboard.loading || state.organization.loading,
    organization: state.organization.current,
});

export default connect(mapStateToProps, {organizationRequest, requestDashboard})(PrintableDashboard);
